import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-anlegen';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentAnlegenEffects {

    IncidentAnlegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_ANLEGEN),
        mergeMap((x: ac.PostIncidentAnlegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentAnlegen(x.incidentBeschreibungRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentAnlegenErfolgreichAction(result, x.incidentBeschreibungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentAnlegenFehlerAction(error, x.incidentBeschreibungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
